import React from 'react';
import * as Icon from 'ubs-icons';
import {COLOR} from "../common/constant";

const UHoursMinutes = React.memo((props) => {
    const convert = {
        stoh: (e) => isNaN(Number(e)) ? 0 : (Math.floor(Number(e) / 3600) || ''),
        stom: (e) => isNaN(Number(e)) ? 0 : (Math.floor(Number(e) % 3600 / 60) || ''),
        htos: (e) => isNaN(Number(e)) ? 0 : (Number(e) * 60 * 60 || ''),
        mtos: (e) => isNaN(Number(e)) ? 0 : (Number(e) * 60 || ''),
        value: (e) => isNaN(Number(e)) ? 0 : (Number(e) || ''),
    }
    const handle = {
        change: (value, name) => {
            if (name === 'hours') {
                const hours = convert.htos(value)
                const minutes = convert.mtos(convert.stom(props.value))
                props.onChange(convert.value(hours + minutes))
            } else if (name === 'minutes') {
                const hours = convert.htos(convert.stoh(props.value))
                const minutes = convert.mtos(value)
                props.onChange(convert.value(hours + minutes))
            }
        }
    }

    const inputs = (
        <div className="u_flex u_align-center">
            <div className={`u_hoursMinutes-inner u_hoursMinutes-hour u_flex ${typeof props?.cn === "string" ? props?.cn : ""}`}>
                <input
                    type={`${props?.hideArrow ? "text" : "number"}`}
                    placeholder=" "
                    name="hours"
                    value={Number(convert.stoh(props?.value))}
                    onChange={e => handle?.change(e?.target?.value, 'hours')}
                    autoComplete="off"
                    onWheelCapture={e => e.target.blur()}
                    disabled={props?.disabled}
                    onKeyDown={e => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
            </div>
            <div className="u_hoursMinutes-separator"></div>
            <div className={`u_hoursMinutes-inner u_hoursMinutes-minute u_flex ${typeof props?.cn === "string" ? props?.cn : ""}`}>
                <input
                    type={`${props?.hideArrow ? "text" : "number"}`}
                    placeholder=" "
                    name="minutes"
                    value={Number(convert.stom(props?.value))}
                    onChange={e => handle?.change(e?.target?.value, 'minutes')}
                    autoComplete="off"
                    onWheelCapture={e => e.target.blur()}
                    disabled={props?.disabled}
                    onKeyDown={e => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
            </div>
        </div>
    );

    // Legacy grid layout (matches the retired module-local copies) — opt-in via `grid`.
    if (props?.grid) {
        return (
            <React.Fragment>
                <div className="u_row">
                    <div className="u_col-6">
                        <div className="u_flex u_content-between">
                            {inputs}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className={'u_flex-align u_content-between'}>
                {inputs}
                {props?.icon && <Icon.Watch size={16} fill={COLOR.u_icon_bg}/>}
            </div>
        </React.Fragment>
    );
});

export default UHoursMinutes;
